import axios from '@/plugins/axios'
import * as typesAPI from '@/models/api/models-api'
import { backendAPIConfig } from '@baseConfig'
import { MembersCardApi } from '@/api/members-card-api'
import { LineOauthApi } from '@/api/line-oauth-api'
import { LineOauthSetupApi } from '@/api/line-oauth-setup-api'
import { CardAlignmentSetupApi } from './card-alignment-setup-api'

class Api {
    /**
     * @public
     * @async
     * @param {typesAPI.GetSampleRequest} request
     * @returns {typesAPI.APIResponse}
     */
    async getSample(request) {
        const res = await axios.get(`${backendAPIConfig.endpoint}/health-check`)
        return res
    }
}

export default {
    /**
     * @param {import('vue').App} app
     * @param {*} options
     */
    install(app, options) {
        const api = new Api()
        app.config.globalProperties.$api = api
        app.config.globalProperties.$membersCardApi = new MembersCardApi()
        app.config.globalProperties.$lineOauthApi = new LineOauthApi()
        app.config.globalProperties.$lineOauthSetupApi = new LineOauthSetupApi()
        app.config.globalProperties.$cardAlignmentSetupApi = new CardAlignmentSetupApi()
    }
}
